<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="分类名称">
                <a-input
                  v-model="queryParam.categoryName"
                  allow-clear
                  placeholder="请输入"
                  @keyup.enter="handleQuery"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择">
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['upkeep:category:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="handleUpdate" v-hasPermi="['upkeep:category:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['upkeep:category:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 弹窗：一层 -->
      <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleCreateFormOk" />
      <!-- 弹窗：二层 -->
      <create-form ref="innerCreateForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleInnerFormOk" />
      <!-- 弹窗：三层 -->
      <create-form ref="grandCreateForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleGrandFormOk" />

      <!-- 主表 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        @expand="onExpand"
      >
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status === 1"
            v-hasPermi="['upkeep:category:edit']"
            @change="handleStatusType(record.id, record.status === 1 ? 0 : 1, 'main', record)"
          />
        </span>
        <span slot="parentId">
          <a-tag color="green">一层</a-tag>
        </span>
        <div slot="pic" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.pic"
              style="width: 50px; height: 50px"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <div slot="icon" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.icon"
              style="width: 50px; height: 50px"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['upkeep:category:edit']">修改</a>
          <a-divider type="vertical" v-hasPermi="['upkeep:category:edit', 'upkeep:category:remove']" />
          <a-dropdown v-hasPermi="['upkeep:category:edit', 'upkeep:category:remove']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()"><a-icon type="double-right" />更多</a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['upkeep:category:add']">
                <a @click="$refs.innerCreateForm.handleAdd(record)">添加</a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['upkeep:category:remove']" v-if="record.status == 0">
                <a @click="handleDelete(record, 'inner')">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          rowKey="id"
          :size="tableSize"
          :columns="innerColumns"
          :data-source="innerData[record.id] || []"
          :loading="innerLoading[record.id]"
          :pagination="innerPaginationVisible[record.id] ? innerPagination[record.id] : false"
          :row-selection="{
            selectedRowKeys: innerSelectedRowKeys[record.id] || [],
            onChange: (k, r) => onInnerSelectChange(k, r, record.id),
          }"
          :bordered="tableBordered"
          @expand="onInnerExpand"
        >
          <!-- <span slot="status" slot-scope="text, subRow">
            <a-tag color="green" v-if="subRow.status == 1">启用</a-tag>
            <a-tag color="red" v-if="subRow.status == 0">禁用</a-tag>
          </span> -->

          <span slot="status" slot-scope="_text, subRow">
            <a-switch
              :checked="subRow.status === 1"
              v-hasPermi="['upkeep:category:edit']"
              @change="handleStatusType(subRow.id, subRow.status === 1 ? 0 : 1, 'inner', subRow)"
            />
          </span>
          <span slot="parentId"><a-tag color="orange">二层</a-tag></span>
          <div slot="pic" slot-scope="text, subRow">
            <div v-viewer>
              <img
                :src="$url + subRow.pic"
                style="width: 50px; height: 50px"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </div>

          <div slot="icon" slot-scope="text, subRow">
            <div v-viewer>
              <img
                :src="$url + subRow.icon"
                style="width: 50px; height: 50px"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </div>
          <span slot="operation" slot-scope="text, subRow">
            <a @click="$refs.innerCreateForm.handleUpdate(subRow, undefined)">修改</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()"><a-icon type="double-right" />更多</a>
              <a-menu slot="overlay">
                <a-menu-item><a @click="$refs.grandCreateForm.handleAdd(subRow)">新增</a></a-menu-item>
                <a-menu-item v-if="subRow.status == 0"><a @click="handleDelete(subRow, 'grand')">删除</a></a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>

          <a-table
            slot="expandedRowRender"
            slot-scope="subRecord"
            rowKey="id"
            :size="tableSize"
            :columns="grandColumns"
            :data-source="grandData[subRecord.id] || []"
            :loading="grandLoading[subRecord.id]"
            :pagination="grandPagination[subRecord.id] || false"
            :row-selection="{
              selectedRowKeys: grandSelectedRowKeys[subRecord.id] || [],
              onChange: (k, r) => onGrandSelectChange(k, r, subRecord.id),
            }"
            :bordered="tableBordered"
            @change="(p) => handleGrandPageChange(p, subRecord)"
          >
            <span slot="status" slot-scope="_text, gRow">
              <a-switch
                :checked="gRow.status === 1"
                v-hasPermi="['upkeep:category:edit']"
                @change="handleStatusType(gRow.id, gRow.status === 1 ? 0 : 1, 'grand', gRow)"
              />
            </span>
            <span slot="parentId"><a-tag color="red">三层</a-tag></span>
            <div slot="pic" slot-scope="text, gRow">
              <div v-viewer>
                <img
                  :src="$url + gRow.pic"
                  style="width: 60px; height: 60px; object-fit: contain"
                  @error="(e) => (e.target.src = errorImage)"
                />
              </div>
            </div>
            <div slot="icon" slot-scope="text, gRow">
              <div v-viewer>
                <img
                  :src="$url + gRow.icon"
                  style="width: 60px; height: 60px; object-fit: contain"
                  @error="(e) => (e.target.src = errorImage)"
                />
              </div>
            </div>
            <span slot="operation" slot-scope="_text, gRow">
              <span :class="getOpCls(gRow)">
                <a @click="$refs.grandCreateForm.handleUpdate(gRow, undefined, 'grand')">修改</a>
                <a-divider type="vertical" />
                <a-dropdown>
                  <a class="ant-dropdown-link">更多<a-icon type="double-right" /></a>
                  <a-menu slot="overlay">
                    <a-menu-item v-if="gRow.status == 0">
                      <a @click="handleDelete(gRow, 'grand')">删除</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </span>
            </span>
          </a-table>
        </a-table>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, statusObj } from '@/api/maintenance/classification/index.js'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Category',
  components: { CreateForm },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      list: [],
      // 行级锁：key=行id，value=是否正在提交
      statusSubmitting: {},
      // 需要局部更新的表类型：main | inner | grand
      updateLevel: 'main',
      // 当前正在操作的行（用于局部刷新）
      updatingRow: null,
      selectedRowKeys: [],
      selectedRows: [],
      innerSelectedRowKeys: {},
      grandSelectedRowKeys: {},
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      errorImage: require('/src/assets/images/defaultImg.png'),
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        categoryName: undefined,
        parentId: 0,
        status: undefined,
      },
      innerPaginationVisible: {},
      innerData: {},
      innerLoading: {},
      innerPagination: {},
      grandData: {},
      grandLoading: {},
      grandPagination: {},
      currentParentId: null,
      currentGrandParentId: null,
      columns: [
        { title: '分类名称', dataIndex: 'categoryName', align: 'center' },
        { title: '分类层级', dataIndex: 'parentId', scopedSlots: { customRender: 'parentId' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '类目图片', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '类目图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      innerColumns: [
        { title: '分类名称', dataIndex: 'categoryName', align: 'center' },
        { title: '分类层级', dataIndex: 'parentId', scopedSlots: { customRender: 'parentId' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '类目图片', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '类目图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      grandColumns: [
        { title: '分类名称', dataIndex: 'categoryName', align: 'center' },
        { title: '分类层级', dataIndex: 'parentId', scopedSlots: { customRender: 'parentId' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '类目图片', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '类目图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10, categoryName: undefined, parentId: 0, status: undefined }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.updateMultipleStatus()
    },
    onInnerSelectChange(keys, rows, pid) {
      this.$set(this.innerSelectedRowKeys, pid, keys)
      this.updateMultipleStatus()
    },
    onGrandSelectChange(keys, rows, pid) {
      this.$set(this.grandSelectedRowKeys, pid, keys)
      this.updateMultipleStatus()
    },
    /**
     * 更新删除按钮的禁用状态，检查所有层级是否有选择
     */
    updateMultipleStatus() {
      // 检查主表格是否有选择
      const hasMainSelection = this.selectedRowKeys.length > 0

      // 检查二级表格是否有选择
      const hasInnerSelection = Object.values(this.innerSelectedRowKeys).some((keys) => keys && keys.length > 0)

      // 检查三级表格是否有选择
      const hasGrandSelection = Object.values(this.grandSelectedRowKeys).some((keys) => keys && keys.length > 0)

      // 如果任何层级有选择，则不禁用删除按钮
      this.multiple = !(hasMainSelection || hasInnerSelection || hasGrandSelection)
    },
    /**
     * 切换状态
     * @param {Number} id        行 id
     * @param {Number} newStatus 目标状态 0/1
     * @param {String} level     所在表格层级 main | inner | grand
     * @param {Object} row       当前行数据（用于局部刷新失败回滚）
     */
    async handleStatusType(id, newStatus, level = 'main', row = null) {
      // 1. 防重复点击
      if (this.statusSubmitting[id]) return
      this.$set(this.statusSubmitting, id, true)
      this.updateLevel = level
      this.updatingRow = row

      // 2. 立即本地生效（失败再回滚）
      const oldStatus = row ? row.status : level === 'main' ? this.list.find((i) => i.id === id)?.status : undefined
      if (row) row.status = newStatus // 局部行数据先改

      // 3. 调接口
      try {
        await statusObj({ id, status: newStatus })
        this.$message.success('状态更新成功')
        // 4. 局部刷新：只重载当前表，而不是整页 getList
        this.reloadCurrentTable()
      } catch (e) {
        // 5. 失败回滚
        if (row) row.status = oldStatus
        this.$message.error(e.msg || '状态更新失败')
      } finally {
        this.$set(this.statusSubmitting, id, false)
      }
    },
    /* 根据 level 只刷新对应的表格 */
    reloadCurrentTable() {
      switch (this.updateLevel) {
        case 'main':
          this.getList() // 父表
          break
        case 'inner':
          this.loadInner(
            { id: this.currentParentId },
            this.innerPagination[this.currentParentId]?.current || 1,
            this.innerPagination[this.currentParentId]?.pageSize || 5
          )
          break
        case 'grand':
          this.loadGrand(
            { id: this.currentGrandParentId },
            this.grandPagination[this.currentGrandParentId]?.current || 1,
            this.grandPagination[this.currentGrandParentId]?.pageSize || 5
          )
          break
      }
    },
    handleAdd() {
      this.$refs.createForm.handleAdd()
    },
    handleUpdate() {
      const id = this.selectedRowKeys[0]
      this.$refs.createForm.handleUpdate({ id })
    },
    handleDelete(row, level = 'main') {
      // 如果有row参数，说明是单个删除（从操作列点击）
      if (row && row.id) {
        this.$confirm({
          title: '是否确认删除此数据?',
          onOk: () =>
            delObj([{ id: row.id }]).then(() => {
              this.$message.success('删除成功', 3)
              if (level === 'main') {
                this.onSelectChange([], [])
                this.getList()
              } else if (level === 'inner') {
                this.loadInner(
                  { id: this.currentParentId },
                  this.innerPagination[this.currentParentId]?.current || 1,
                  this.innerPagination[this.currentParentId]?.pageSize || 5
                )
              } else if (level === 'grand') {
                this.loadGrand(
                  { id: this.currentGrandParentId },
                  this.grandPagination[this.currentGrandParentId]?.current || 1,
                  this.grandPagination[this.currentGrandParentId]?.pageSize || 5
                )
              }
            }),
        })
        return
      }

      // 批量删除逻辑：收集所有层级的选中项
      const allSelectedIds = []

      // 主表格选择
      if (this.selectedRowKeys.length > 0) {
        allSelectedIds.push(...this.selectedRowKeys)
      }

      // 二级表格选择
      Object.values(this.innerSelectedRowKeys).forEach((keys) => {
        if (keys && keys.length > 0) {
          allSelectedIds.push(...keys)
        }
      })

      // 三级表格选择
      Object.values(this.grandSelectedRowKeys).forEach((keys) => {
        if (keys && keys.length > 0) {
          allSelectedIds.push(...keys)
        }
      })

      if (allSelectedIds.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }

      this.$confirm({
        title: `是否确认删除选中的 ${allSelectedIds.length} 条数据?`,
        onOk: () =>
          delObj(allSelectedIds.map((id) => ({ id }))).then(() => {
            this.$message.success('批量删除成功', 3)

            // 清空所有选择
            this.onSelectChange([], [])
            Object.keys(this.innerSelectedRowKeys).forEach((pid) => {
              this.$set(this.innerSelectedRowKeys, pid, [])
            })
            Object.keys(this.grandSelectedRowKeys).forEach((pid) => {
              this.$set(this.grandSelectedRowKeys, pid, [])
            })
            // 更新删除按钮状态
            this.updateMultipleStatus()

            // 刷新所有表格
            this.getList()

            // 刷新所有展开的二级表格
            Object.keys(this.innerData).forEach((pid) => {
              if (this.innerPagination[pid]) {
                this.loadInner(
                  { id: pid },
                  this.innerPagination[pid].current || 1,
                  this.innerPagination[pid].pageSize || 5
                )
              }
            })

            // 刷新所有展开的三级表格
            Object.keys(this.grandData).forEach((pid) => {
              if (this.grandPagination[pid]) {
                this.loadGrand(
                  { id: pid },
                  this.grandPagination[pid].current || 1,
                  this.grandPagination[pid].pageSize || 5
                )
              }
            })
          }),
      })
    },
    handleCreateFormOk() {
      this.getList()
    },
    handleInnerFormOk() {
      if (!this.currentParentId || !this.innerPagination[this.currentParentId]) {
        this.getList()
        return
      }
      this.loadInner(
        { id: this.currentParentId },
        this.innerPagination[this.currentParentId].current,
        this.innerPagination[this.currentParentId].pageSize
      )
    },
    handleGrandFormOk() {
      if (!this.currentGrandParentId || !this.grandPagination[this.currentGrandParentId]) {
        this.getList()
        return
      }
      this.loadGrand(
        { id: this.currentGrandParentId },
        this.grandPagination[this.currentGrandParentId].current,
        this.grandPagination[this.currentGrandParentId].pageSize
      )
    },
    onExpand(expanded, record) {
      if (!expanded) return
      this.currentParentId = record.id
      this.$set(this.innerPagination, record.id, {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      })
      this.$set(this.innerPaginationVisible, record.id, true)
      this.loadInner(record)
    },
    loadInner(record, page = 1, size = 5) {
      this.$set(this.innerLoading, record.id, true)
      fetchList({ pageNum: page, pageSize: size, parentId: record.id }).then((res) => {
        this.$set(this.innerData, record.id, res.data.records)
        const pager = this.innerPagination[record.id]
        pager.total = res.data.total
        pager.current = page
        pager.pageSize = size
        this.$set(this.innerLoading, record.id, false)
      })
    },
    handleInnerPageChange(pagination, record) {
      this.loadInner(record, pagination.current, pagination.pageSize)
    },
    onInnerExpand(expanded, record) {
      if (!expanded) {
        this.$set(this.innerPaginationVisible, this.currentParentId, true)
        return
      }
      this.currentGrandParentId = record.id
      this.$set(this.innerPaginationVisible, this.currentParentId, false)
      this.$set(this.grandPagination, record.id, {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      })
      this.loadGrand(record)
    },
    loadGrand(record, page = 1, size = 5) {
      this.$set(this.grandLoading, record.id, true)
      fetchList({ pageNum: page, pageSize: size, parentId: record.id }).then((res) => {
        this.$set(this.grandData, record.id, res.data.records)
        const pager = this.grandPagination[record.id]
        pager.total = res.data.total
        pager.current = page
        pager.pageSize = size
        this.$set(this.grandLoading, record.id, false)
      })
    },
    handleGrandPageChange(pagination, record) {
      this.loadGrand(record, pagination.current, pagination.pageSize)
    },
    getOpCls(record) {
      return this.selectedRowKeys.includes(record.id) ? 'op-highlight' : ''
    },
  },
}
</script>

<style scoped>
.ant-table-thead > tr > th {
  background-color: #303133;
  color: #fff;
  font-weight: 600;
}
.ant-table-tbody > tr:nth-child(even) {
  background-color: #fafafa;
}
.ant-table-tbody > tr:nth-child(odd) {
  background-color: #ffffff;
}
.op-highlight {
  color: #1890ff;
  font-weight: bold;
}
</style>
